import { ISingleIdParams } from '../types/actionParams';
import { IWorkbookActions } from '../types/IWorkbookActions';
import { Request } from './Request';

export class GetWorkbookActionsRequest extends Request<ISingleIdParams, IWorkbookActions> {
  constructor(id: string) {
    super('getWorkbookActions', { id: id });
  }
}
